module.exports = __webpack_public_path__ + "static/media/trash.59ee9dff.svg";